import './AppHeader.scss'
import { useState } from 'react';
import { useHistory } from 'react-router-dom';

import PhoriaLogo from '../../assets/images/phoria-logo-white-256.png'

// Components
import Flex from '../utils/Flex'
import Container from '../utils/Container'
import MobileMenuButton from '../MobileMenuButton';
import NotifyDropdown from '../NotifyDropdown';

const initialNavs = () => [
	{
		type: 'link',
		path: '/home',
		name: 'Home',
		icon: 'home'
	},
	{
		type: 'link',
		path: '/explore',
		icon: 'explore',
		name: 'Explore'
	},
	{
		type: 'link',
		path: '/user/settings',
		icon: 'settings',
		name: 'Settings'
	}
]

const inboxNav = {
	type: 'link',
	path: '/direct/inbox',
	icon: 'mark_email_unread',
	name: 'Inbox'
}

export const vue = {
	watch: {
		'$isAuth': {
			immediate: true,
			handler(isAuth) {
				if (isAuth) {
					this.navs.splice(1, 0, {
						type: 'link',
						path: `/${this.$user.username}`,
						icon: 'contact_mail'
					}, inboxNav, { ...this.notifyDropdown })
					this.mobileNavs.push(inboxNav)
				}
			}
		}
	}
}

const AppHeader = () => {

	const history = useHistory()
	const [menu, setMenu] = useState(false)
	const [navs] = useState(initialNavs())
	const [mobileNavs] = useState(initialNavs())
	const [notifyDropdown] = useState({
		badge: '9+',
		type: 'dropdown',
		icon: 'notifications_active'
	})

	// const isAuthPath = ['/login', '/signup'].includes(window.location.pathname)

	return (
		<header className="header py-3 shadow z-10">
			<Container className="px-2">
				<Flex items-center className="sm:justify-between">
					<button onClick={() => history.push('/')} className="mr-auto sm:mr-0">
						<img
							src={PhoriaLogo}
							alt="PhoriaTV Logo Black White"
							className="w-8 h-8 lg:w-12 lg:h-12 2xl:w-16 2xl:h-16"
						/>
						{/* <Flex
						v-else
						className="bg-secondary2 rounded 2xl:rounded-xl overflow-hidden"
					>
						<img
							alt="PhoriaTVLogo"
							src="../assets/images/PhoriaTVLogo.png"
							className="w-8 h-8 lg:w-12 lg:h-12 2xl:w-16 2xl:h-16"
						/>
						<div
							className="header__title text-base lg:text-2xl 2xl:text-3xl text-white font-bold flex items-center px-2 2xl:px-3"
						>
							PhoriaTV
						</div>
					</Flex>  */}
					</button>
					<Flex className="hidden sm:flex space-x-6 lg:space-x-8 2xl:space-x-10">
						{navs.map((nav, navIndex) => {
							return nav.type === 'link' ? (
								<button
									key={navIndex}
									className="relative"
									onClick={() => history.push(nav.path)}
								>
									<i className="material-icons md:text-2xl lg:text-3xl 2xl:text-4xl">
										{nav.icon}
									</i>
								</button>
							)
								: nav.type === 'dropdown'
									? <NotifyDropdown nav={nav} key={navIndex} />
									: null
						})}
						<NotifyDropdown nav={notifyDropdown} className="sm:hidden mr-4" />
					</Flex>
					<MobileMenuButton value={menu} onChange={v => setMenu(v)} />
				</Flex>
				{menu && (
					<div className="md:hidden pt-5 space-y-1">
						{mobileNavs.map((nav, navIndex) => (
							<Flex
								items-center
								to={nav.path}
								key={navIndex}
								className="px-4 py-2 text-base"
							>
								<i className="material-icons">{nav.icon}</i>
								<span className="ml-3">{nav.name}</span>
							</Flex>
						))}
					</div>
				)}
			</Container>
		</header>
	)
}

export default AppHeader